import React from "react";
import { Link } from "react-router-dom";
import "./category.css";

const Category = ({ catgBlogsCount }) => {
  return (
    <div className="containerCategory">
      <div className="categoryTitle">Categories</div>

      <div className="contentCategory">
        {catgBlogsCount?.map((item, index) => (
          <Link
            key={index}
            to={`/category/${item.category}`}
            style={{ textDecoration: "none" }}
          >
            <div className="category-item">
              <span className="category-name">{item.category}</span>
              <span className="category-count">{item.count}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Category;
